import * as uuid from 'uuid';
import mainStyles from '../../pages/main.module.css';
import styles from './checkModalBody.module.css';

interface Props {
  title: string;
  items: string[];
  footer?: string;
  cartMessage?: string | null;
  grayBackgroundItems?: boolean;
}

export default function CheckModalBody({
  title,
  items,
  footer = '',
  cartMessage,
  grayBackgroundItems,
}: Props) {
  return (
    <div style={{ whiteSpace: 'pre-wrap' }}>
      {title}
      <br />
      <br />
      <div className={grayBackgroundItems ? styles.grayBackgroundItems : ''}>
        {items.slice(0, 5).map((item) => (
          <div key={uuid.v1()} className={mainStyles['text-overflow-ellipsis']}>
            -
            {' '}
            {item}
          </div>
        ))}
        {items.length > 5 && (
        <div>
          その他
            {items.length - 5}
          件
        </div>
        )}
      </div>
      {cartMessage && (
        <>
          <br />
          <div>
            {cartMessage}
          </div>
        </>
      )}
      {footer !== '' ? (
        <>
          <br />
          <div>
            {footer}
          </div>
        </>
      ) : null}
    </div>
  );
}
